<template>
    <div class="mobile-top-bar-container" @click="openMenu()">
        <dashboard-ylands-icon class="mobile-top-bar-container__icon">
        </dashboard-ylands-icon>
        <div class="mobile-top-bar-container__title">
            Ylands <br /><strong>Dashboard</strong>
        </div>
        <expand-arrow
            v-if="!showMenu"
            class="mobile-top-bar-container__arrow"
        ></expand-arrow>
        <expand-arrow
            v-else
            class="mobile-top-bar-container__arrow-down"
        ></expand-arrow>
    </div>
</template>

<script>
import DashboardYlandsIcon from 'Svgs/dashboard_ylands_ico.svg?inline';
import ExpandArrow from 'Svgs/expand-arrow.svg?inline';

export default {
    name: 'MobileTopbar',
    components: {
        DashboardYlandsIcon,
        ExpandArrow,
    },
    data() {
        return {
            showMenu: false,
        };
    },
    methods: {
        openMenu() {
            this.showMenu = !this.showMenu;
            this.$emit('show-menu', this.showMenu);
        },
    },
};
</script>

<style scoped lang="scss">
.mobile-top-bar-container {
    cursor: pointer;
    display: grid;
    grid-template-columns: 12% 68% 20%;
    &__icon {
        width: 44px;
        grid-column: 1;
        margin: 1.3rem;
        @media (max-width: $lg-up) {
            margin: 1.4rem auto 0 2rem;
        }
        @media (max-width: $sm-up) {
            margin: 1.4rem auto auto 2rem;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 0.8rem auto auto 2rem;
            width: 26px;
        }
    }
    &__title {
        margin: 1.5rem;
        grid-column: 2;
        width: 130px;
        height: 35px;
        color: #0a294a;
        font-family: $politica-font;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 0.73px;
        line-height: 18px;
        @media (min-width: $sm-up) and (max-width: $lg-up) {
            margin: 1.5rem auto 0 -1rem;
        }
        @media (min-width: $xs-up) and (max-width: $sm-up) {
            margin: 1.5rem auto auto 1rem;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 0.8rem auto auto 1.5rem;
            font-size: 12px;
            width: 74px;
            height: 26px;
            color: #0a294a;
            letter-spacing: 0.55px;
            line-height: 13px;
        }
    }
    &__arrow {
        grid-column: 3;
        width: 20px;
        margin: 2rem 2rem auto auto;
        transform: rotate(-90deg);

        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 12px;
            fill: #95a3b0;
            margin: 1.2rem 2rem auto auto;
        }
    }
    &__arrow-down {
        grid-column: 3;
        width: 20px;
        margin: 2rem 2rem auto auto;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 12px;
            fill: #95a3b0;
            margin: 1.2rem 2rem auto auto;
        }
    }
}
</style>
